import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fivezeroseaterbusonrentinpune() {



  const cardData =
  {
    keyword: '50 Seater Bus On Rent in Pune ',
    heading: 'Sanavi Travels: 50 Seater Bus On Rent in Pune',
    headingDescription: 'Sanavi Travels offers reliable 50 Seater Bus On Rent in Pune, providing safe, comfortable, and hassle-free transportation for very large groups including corporate teams, schools and colleges, tour operators, wedding guests, religious tours, and major events. Our well-maintained 50 seater buses are ideal for long-distance travel, large corporate outings, educational tours, and mass group movement, featuring spacious seating, air-conditioned interiors, ample luggage space, and smooth ride comfort. With experienced and licensed chauffeurs, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Sanavi Travels ensures a smooth, punctual, and comfortable journey. From doorstep pickup across Pune—including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, and Pune Airport—to drop-off at destinations such as Lonavala, Mahabaleshwar, Shirdi, Nashik, Mumbai, Goa, and other outstation routes, Sanavi Travels provides trusted 50 Seater Bus rental services in Pune for customers seeking comfort, safety, and dependable large-group transportation.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light-and-sound show vividly brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage, valor, and architectural brilliance."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum showcasing Gandhi’s personal artifacts, photographs, and historical documents. The palace’s sprawling gardens, Italian arches, and serene ambiance make it a peaceful retreat. The site also houses the samadhis of Kasturba Gandhi and Mahadev Desai, making it a symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations with music, decorations, and cultural events. The trust behind the temple is also known for extensive charitable work. Devotees find immense peace, blessings, and spiritual solace here. Dagdusheth Ganpati remains the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking views of the Sahyadri ranges, dotted with lush greenery. Local vendors serve traditional pithla-bhakri meals near the summit. Sinhagad is Pune’s favorite blend of history, adventure, and nature, attracting both historians and thrill-seekers."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi pavilion, and a serene sanctum. Despite being located in a busy urban area, it maintains a tranquil spiritual ambiance. Its ancient carvings showcase the mastery of early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage retreat, offering peace, meditation, and a connection with the city’s ancient past."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. The collection includes traditional ornaments, musical instruments, household antiques, and sculptures. The recreated Mastani Mahal is a major attraction, depicting the lifestyle of historical India. The museum serves as a living archive of art, craftsmanship, and history, making it an invaluable destination for art lovers, students, and tourists seeking cultural insights."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing. Parvati Hill is Pune’s spiritual and scenic high point, attracting devotees, history enthusiasts, and nature lovers alike."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation, rejuvenation, and personal transformation. Osho Ashram is Pune’s international retreat for tranquility, blending spiritual learning with holistic wellness practices."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families, joggers, and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature, offering a serene sanctuary within Pune’s urban landscape. It is an ideal spot for relaxation, picnics, and reconnecting with nature."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during the monsoon season. Street vendors selling roasted corn, tea, and local snacks add to its charm. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends, sunset views, and family outings, offering both natural beauty and recreational opportunities."
  }
]
,





"services": [
    {
      "name": "50 Seater Bus On Rent in Pune",
      "description": "50 Seater Bus On Rent in Pune provides spacious and comfortable buses for large groups traveling within Pune and nearby regions. Ideal for weddings, corporate events, school trips, family outings, and sightseeing tours, these buses feature ample seating, luggage compartments, and modern amenities. Professional drivers ensure safe, smooth, and punctual journeys. Flexible rental options and transparent pricing make it convenient for both short and long-distance trips."
    },
    {
      "name": "50 Seater Bus Hire Pune",
      "description": "50 Seater Bus Hire Pune offers flexible rental services for day trips, outstation travel, and group events. Well-maintained buses accommodate large groups comfortably, with spacious interiors, air-conditioning, and luggage space. Experienced chauffeurs handle routes efficiently, ensuring timely arrivals, safety, and a stress-free journey. Perfect for corporate outings, family vacations, and group tours."
    },
    {
      "name": "AC 50 Seater Bus Pune",
      "description": "AC 50 Seater Bus Pune provides air-conditioned buses for a comfortable and cool travel experience. Ideal for long-distance journeys, corporate travel, family trips, and sightseeing tours, these buses offer spacious seating, luggage-friendly interiors, and modern amenities. Professional drivers ensure safe driving, optimized routes, and smooth travel, allowing passengers to relax and enjoy the journey."
    },
    {
      "name": "Luxury Bus Rental Pune",
      "description": "Luxury Bus Rental Pune offers premium 50 seater buses with well-appointed interiors, reclining seats, entertainment options, and ample luggage space. Perfect for VIP travel, weddings, corporate events, and group tours, these buses combine elegance with convenience. Experienced chauffeurs ensure timely, safe, and professional service, making the journey comfortable and stress-free."
    },
    {
      "name": "50 Seater Bus for Wedding Pune",
      "description": "50 Seater Bus for Wedding Pune provides reliable and spacious transportation for wedding guests. Ideal for ceremonies, pre-wedding events, and guest transfers, these buses ensure comfort, safety, and punctuality. Passengers benefit from ample seating, luggage space, and professional drivers, making wedding travel seamless and hassle-free."
    },
    {
      "name": "Corporate 50 Seater Bus Pune",
      "description": "Corporate 50 Seater Bus Pune caters to office groups, business travelers, and corporate events. Buses offer spacious seating, work-friendly interiors, and luggage compartments. Professional chauffeurs maintain punctuality and safety, allowing employees or executives to rest or focus on work during travel. Ideal for conferences, team outings, client visits, or corporate tours."
    },
    {
      "name": "Outstation 50 Seater Bus Pune",
      "description": "Outstation 50 Seater Bus Pune provides reliable and comfortable transport for long-distance trips. Suitable for weekend getaways, sightseeing tours, corporate retreats, or school trips, these buses feature ample seating, luggage-friendly interiors, and experienced drivers. Safety, comfort, and punctuality are ensured for a smooth and enjoyable outstation travel experience."
    },
    {
      "name": "Affordable 50 Seater Bus Pune",
      "description": "Affordable 50 Seater Bus Pune offers budget-friendly rental options for large groups without compromising comfort or safety. Well-maintained buses, ample seating, luggage space, and professional drivers ensure a convenient and stress-free journey. Ideal for family trips, friends traveling together, corporate events, or group excursions, combining affordability with reliability."
    },
    {
      "name": "Chauffeur Driven 50 Seater Bus",
      "description": "Chauffeur Driven 50 Seater Bus provides skilled and professional drivers for a hassle-free travel experience. Passengers can relax while chauffeurs handle routes, traffic, and highway driving. Spacious interiors, luggage-friendly compartments, and modern amenities ensure comfort for families, friends, corporate groups, or event travel."
    },
    {
      "name": "Group Travel 50 Seater Bus Pune",
      "description": "Group Travel 50 Seater Bus Pune is designed for large groups including families, friends, school trips, or corporate teams. Buses are spacious, comfortable, and equipped for long journeys. Professional drivers ensure timely arrivals, safe driving, and smooth travel. Ideal for sightseeing, weddings, corporate outings, or leisure tours."
    },
    {
      "name": "Best 50 Seater Bus Pune",
      "description": "Best 50 Seater Bus Pune offers top-quality vehicles and professional service for a superior travel experience. Comfortable interiors, well-maintained buses, skilled drivers, and passenger-focused amenities make journeys safe, smooth, and enjoyable. Suitable for weddings, corporate trips, family tours, and large group excursions."
    },
    {
      "name": "Pune Bus Booking Service",
      "description": "Pune Bus Booking Service allows easy online and offline booking of 50 seater buses. Flexible scheduling, transparent pricing, and reliable vehicles ensure convenient travel. Suitable for corporate trips, family outings, weddings, sightseeing tours, and group travel around Pune and nearby areas."
    },
    {
      "name": "Tourist Bus Hire Pune",
      "description": "Tourist Bus Hire Pune provides dependable buses for sightseeing, leisure travel, and group tours. Spacious seating, luggage-friendly interiors, and professional drivers ensure comfort and safety throughout the journey. Ideal for tourists exploring Pune and surrounding destinations."
    },
    {
      "name": "Event Bus Rental Pune",
      "description": "Event Bus Rental Pune offers reliable transportation for weddings, corporate events, parties, and special occasions. Buses provide spacious seating, luggage compartments, and professional chauffeurs for safe, timely, and convenient travel. Perfect for transporting large groups to events."
    },
    {
      "name": "Family Trip Bus Pune",
      "description": "Family Trip Bus Pune ensures safe, comfortable, and spacious transport for family travel. Ideal for long-distance trips, vacations, weekend getaways, and sightseeing tours, these buses provide ample seating, luggage space, and experienced drivers. Passengers enjoy convenient and stress-free travel."
    }
  ],
  "tableData": [
    ["50 Seater Bus On Rent in Pune", "50 Seater Bus Hire Pune"],
    ["AC 50 Seater Bus Pune", "Luxury Bus Rental Pune"],
    ["50 Seater Bus for Wedding Pune", "Corporate 50 Seater Bus Pune"],
    ["Outstation 50 Seater Bus Pune", "Affordable 50 Seater Bus Pune"],
    ["Chauffeur Driven 50 Seater Bus", "Group Travel 50 Seater Bus Pune"],
    ["Best 50 Seater Bus Pune", "Pune Bus Booking Service"],
    ["Tourist Bus Hire Pune", "Event Bus Rental Pune"],
    ["Family Trip Bus Pune", "—"]
  ]
,


"whychoose": [
  {
    "WhyChooseheading": "50 Seater Bus On Rent in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides reliable 50-seater bus rental services in Pune, ideal for large group tours, corporate trips, school/college outings, and long-distance travel with maximum comfort and safety."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable 50-Seater Buses",
    "WhyChoosedescription": "Travel in air-conditioned, well-maintained 50-seater buses offering ample legroom, comfortable seating, and a smooth ride for all passengers."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pune Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with Pune city, highways, and surrounding areas, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers upfront and clear pricing for 50-seater bus rentals, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, route planning, and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from half-day, full-day, or customized rental plans to meet your group’s travel requirements in Pune."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All 50-seater buses are thoroughly cleaned and sanitized before every trip to ensure passenger safety and hygiene."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for 50-seater bus rentals in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide 50-seater bus on rent in Pune?',
    answer: 'Yes, Sanavi Travels offers well-maintained and comfortable 50-seater buses for large group travel in Pune.'
  },
  {
    question: 'How can I book a 50-seater bus in Pune with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What seating capacity does the 50-seater bus offer?',
    answer: 'The bus comfortably accommodates 50 passengers, suitable for large groups and long-distance travel.'
  },
  {
    question: 'Are drivers included in the 50-seater bus rental?',
    answer: 'Yes, all rentals include experienced and professional drivers.'
  },
  {
    question: 'Is the 50-seater bus rental service available 24x7?',
    answer: 'Yes, our service is available round the clock for bookings and travel.'
  },
  {
    question: 'Are the vehicles sanitized before trips?',
    answer: 'Yes, all 50-seater buses are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the 50-seater bus rental plan?',
    answer: 'Absolutely. Sanavi Travels offers customized rental plans according to your group’s travel needs.'
  },
  {
    question: 'What payment options are available for 50-seater bus bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Santosh Patil',
    feedback: 'Booked a 50-seater bus from Sanavi Travels. Very spacious, clean, and comfortable. Excellent service for our large group in Pune.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Riya Kulkarni',
    feedback: 'Outstanding experience! The bus was comfortable, driver professional, and the service on-time. Highly recommended for group travel in Pune.',
    rating: 5
  }
];































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "50 Seater Bus On Rent in Pune - Sanavi Travels",
  "description": "50 Seater bus on rent in Pune by Sanavi Travels for weddings, corporate travel, outstation trips, family tours, events, and group journeys. Choose AC and luxury 50 seater buses for comfortable and affordable travel in Pune and nearby areas.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2085"
  }
};




  return (
    <div>

<Helmet>
  <title>
    50 Seater Bus On Rent in Pune Starting from ₹60 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book 50 Seater bus on rent in Pune with Sanavi Travels. AC and luxury 50 seater bus for weddings, corporate travel, outstation trips, family tours, events, and group travel at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/17.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fivezeroseaterbusonrentinpune;